<template>
  <div class="logo" @click="itemClick">
    <img v-if="logo !== true" class="fba-logo"  src="../../assets/img/logo3.png" alt="">
    <!-- <h5 v-if="logo !== true">跨境电商运营前线</h5> -->
    <img v-else class="fba" src="../../assets/img/logo3.png" alt="">
    
  </div>
</template>

<script>
  export default {
    name: "logo",
    methods: {
      itemClick(){
        this.$router.replace('/index')
      }
    },
    props:{
      logo:{
        type: Boolean,
        default: false
      }
    },
    created() {
      // console.log(this.logo)
    },
  }
</script>

<style scoped>
  .logo{
    text-align: center;
    position: relative;
    /*margin-top: 20px;*/
  }

  .fba-logo{
      width: 170px;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    
  .fba{
    width: 260px !important;
    position: absolute !important;
    top: 50%;
    transform: translateY(30%);
  }

  .logo:hover{
    cursor: pointer;
  }

  .logo h5{
    color: white;
    /* color: #04a7f4; */
    font-weight: bold;
    /* font-weight: 400; */
    padding-bottom: 10px;
      font-size: 15px;
      min-width: 200px;
  }

</style>
